import { Layer20Filled } from "@fluentui/react-icons";
import { SideDrawer } from "../Generic/SideMenu/SideDrawer";
import { AssetTreeStatus, useAssetTree } from "../AssetTreeShared";
import { StopCodingAssetTree } from "./StopCodingAssetTree";

interface StopCodingDrawerProps {
    className?: string;
    startOpen: boolean;
}

export default function StopCodingDrawer(props: StopCodingDrawerProps) {
    const assetTree = useAssetTree();

    return (
        <SideDrawer
            title="Assets"
            startOpen={props.startOpen}
            className={props.className}
            collapsedIcon={<Layer20Filled className="absolute top-1 left-0.5" />}
        >
            {assetTree.status === "ready"
                ? <StopCodingAssetTree asset={assetTree.asset} />
                : <AssetTreeStatus status={assetTree.status} />}
        </SideDrawer>
    );
}
